<template>
  <div class="oracle-circuit-breaker">
    <v-layout class="oracle-circuit-breaker-wrapper transition-all" column>
      <div
        class="oracle-circuit-breaker-title"
        v-html="$t('common.message.oracleCircuitBreaker')"
      />
      <v-progress-linear
        class="oracle-circuit-breaker-progress"
        color="white"
        height="4"
        rounded
        indeterminate
      />
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'OracleCircuitBreaker',
};
</script>

<style scoped>
.oracle-circuit-breaker {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background-color: #00000066;
  z-index: 97;
}

.oracle-circuit-breaker-wrapper {
  max-width: 500px;
}

.oracle-circuit-breaker:active .oracle-circuit-breaker-wrapper {
  transform: scale(0.95);
}

.oracle-circuit-breaker-title {
  padding: 12px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  user-select: none;
}

.oracle-circuit-breaker-progress {
}
</style>

<style>
.oracle-circuit-breaker {
  box-shadow: none !important;
}
</style>
